<template>
  <div>
    <div v-if="!isEmptyProjects">
      <router-view v-if="isProjectIdExist" />
      <div class="page" v-if="!isProjectIdExist">
        <LayoutContainer>
          <div class="page-content">
            <EmptyMessage>
              <span slot="icon">
                <img src="@/assets/image/lighthouse.png"/>
              </span>
              <h1 slot="title" class="title">ไม่พบโปรเจคต์ '{{projectId}}' :(</h1>
              <p>ลองตรวจสอบ Project URL ที่เข้าใช้งานอีกครั้ง</p>
            </EmptyMessage>
          </div>
        </LayoutContainer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LayoutContainer from '@/layout/LayoutContainer.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  components: {
    LayoutContainer,
    EmptyMessage,
  },
  computed: {
    ...mapGetters(['getProjectById', 'isEmptyProjects']),
    projectId() {
      return this.$route.params.projectId;
    },
    teamName() {
      return this.$route.params.teamName;
    },
    isProjectIdExist() {
      return this.getProjectById(this.projectId);
    },
  },
  watch: {
    projectId(value) {
      this.setCurrentProject(value);
    },
  },
  created() {
    this.setCurrentProject(this.projectId);
  },
  methods: {
    setCurrentProject(projectId) {
      const currentProject = this.getProjectById(projectId);
      this.$store.dispatch('setCurrentProject', currentProject);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';

</style>
